<template>
  <div class="layout__position-left layout__width-100 layout__margin__bottom-10">
    <el-form
      :model="searchParams"
      status-icon
      :rules="{}"
      ref="searchParams"
    >

      <div class="layout__padding-clear text__align-center layout__width-100">
        <div class="layout__search-field__insights-8">
          <p class="layout__margin__bottom-10 text__align-left">Territory</p>
          <el-form ref="customer">
            <el-form-item prop="search">
              <el-select
                v-model="searchParams.reportType"
                filterable
                placeholder="Territory"
                :clearable="false"
                @change="handleReportTypeSelect"
              >
                <el-option
                  v-for="reportType in reportTypes"
                  :key="reportType.value"
                  :label="reportType.name"
                  :value="reportType.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

    </el-form>

    <el-button
      class="button-teal button__base button__insights"
      :disabled="this.sales.length === 0"
      @click="csv"
    >
      Download CSV
    </el-button>
  </div>
</template>

<script>
import Axios from 'axios';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import NewBranches from '../../enums/NewBranches';

export default {
  name: 'NewBranchesSearch',

  mixins: [axios, csvDownloadHelper, dataFormatter],

  props: {
    searchParams: {},

    sales: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isLoading: false,
      serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
      exportDate: new Date().toLocaleDateString('en-GB') + '_new_branches.csv',
      newBranches: NewBranches,
      downloadUrl: '',
      reportTypes: [
        {
          name: 'Corporates',
          value: 'CORPORATES',
        },
        {
          name: 'Non-corporates',
          value: 'NON-CORPORATES',
        },
      ],
    };
  },

  watch: {
    currentPage() {
      this.getSales();
    },

    total() {
      this.getSales();
    },
  },

  computed: {
    currentPage() {
      return this.searchParams.currentPage;
    },

    total() {
      return this.searchParams.total;
    },
  },

  mounted() {
    this.getSales();
  },

  methods: {
    getSales() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      const endpoint = `${this.serviceRouteUrl}/api/v1/DynamicQuery/GetNewBranches?reportType=${this.searchParams.reportType}&getCount=0&cnt=${this.searchParams.pagination}&start=${this.searchParams.pagination * (this.searchParams.currentPage - 1)}`;

      this.$parent.loading = true;

      Axios.get(endpoint, this.returnHeaderUsingToken())
        .then(response => {
          this.$parent.sales = response.data?.length ? response.data : [];

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$parent.loading = false;
          });

          this.isLoading = false;
        })
        .catch(error => {
          if (error.response) {
            this.$message.error('Sorry there has been an issue retrieving the information you requested.');
          }

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$parent.loading = false;
          });

          this.$parent.sales = [];

          this.isLoading = false;
        });
    },

    csv() {
      const fields = this.newBranches.createLabelValueList();

      this.downloadCsv(this.exportDate, fields, this.sales);
    },

    handleReportTypeSelect() {
      this.$emit('report-type-changed');
    },
  },
};
</script>